module.exports = __webpack_public_path__ + "efbb77eaa011a6d108003d067b689b2d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ranks/school-comp-medal-1-basic.png
// module id = 3586
// module chunks = 0